module.exports = {
	"ha": "bc",
	"id": 5.7,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2019 Q1–2020 Q4",
		"lastYear": "2020",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Health Authority, Year Ending 2020 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -185,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 98.77533783783784,
						"dataLabels": {
							"enabled": true,
							"format": "2339"
						}
					},
					{
						"y": 86.40202702702703,
						"dataLabels": {
							"enabled": true,
							"format": "2046"
						}
					},
					{
						"y": 81.9679054054054,
						"dataLabels": {
							"enabled": true,
							"format": "1941"
						}
					},
					{
						"y": 76.81587837837837,
						"dataLabels": {
							"enabled": true,
							"format": "1819"
						}
					},
					{
						"y": 56.33445945945946,
						"dataLabels": {
							"enabled": true,
							"format": "1334"
						}
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": true,
							"format": "673"
						}
					},
					{
						"y": 81.87221396731054,
						"dataLabels": {
							"enabled": true,
							"format": "551"
						}
					},
					{
						"y": 79.64338781575037,
						"dataLabels": {
							"enabled": true,
							"format": "536"
						}
					},
					{
						"y": 73.40267459138187,
						"dataLabels": {
							"enabled": true,
							"format": "494"
						}
					},
					{
						"y": 45.46805349182764,
						"dataLabels": {
							"enabled": true,
							"format": "306"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.09120521172639,
						"dataLabels": {
							"enabled": true,
							"format": "295"
						}
					},
					{
						"y": 80.45602605863192,
						"dataLabels": {
							"enabled": true,
							"format": "247"
						}
					},
					{
						"y": 76.8729641693811,
						"dataLabels": {
							"enabled": true,
							"format": "236"
						}
					},
					{
						"y": 67.10097719869707,
						"dataLabels": {
							"enabled": true,
							"format": "206"
						}
					},
					{
						"y": 32.24755700325733,
						"dataLabels": {
							"enabled": true,
							"format": "99"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.75784753363229,
						"dataLabels": {
							"enabled": true,
							"format": "4796"
						}
					},
					{
						"y": 84.2845495311863,
						"dataLabels": {
							"enabled": true,
							"format": "4135"
						}
					},
					{
						"y": 78.96453322462291,
						"dataLabels": {
							"enabled": true,
							"format": "3874"
						}
					},
					{
						"y": 73.01263758662861,
						"dataLabels": {
							"enabled": true,
							"format": "3582"
						}
					},
					{
						"y": 54.74928658785161,
						"dataLabels": {
							"enabled": true,
							"format": "2686"
						}
					},
					{
						"y": null
					},
					{
						"y": 99.11582670203359,
						"dataLabels": {
							"enabled": true,
							"format": "1121"
						}
					},
					{
						"y": 87.70999115826702,
						"dataLabels": {
							"enabled": true,
							"format": "992"
						}
					},
					{
						"y": 84.3501326259947,
						"dataLabels": {
							"enabled": true,
							"format": "954"
						}
					},
					{
						"y": 77.27674624226348,
						"dataLabels": {
							"enabled": true,
							"format": "874"
						}
					},
					{
						"y": 54.02298850574713,
						"dataLabels": {
							"enabled": true,
							"format": "611"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -1.22466216216216,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.526720820863613,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.13196480938416,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.285419886656363,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.663001649257833,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.127786032689453,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.722323049001818,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.835820895522383,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -38.056680161943326,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.9087947882736174,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.271186440677965,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.453441295546556,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.711864406779661,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -51.94174757281553,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.2421524663677084,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.782318598832354,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.311970979443771,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.537429013939079,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.013958682300384,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.8841732979664063,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.507582515611059,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.8306451612903247,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.38574423480084,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.09153318077803,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Fraser Health<br>n=2368"
			},
			{
				"x": 9,
				"text": "Interior Health<br>n=673"
			},
			{
				"x": 15,
				"text": "Northern Health<br>n=307"
			},
			{
				"x": 21,
				"text": "Vancouver Coastal Health<br>n=4906"
			},
			{
				"x": 27,
				"text": "Vancouver Island Health<br>n=1131"
			}
		],
		"dataTable": {
			"Fraser Health": [
				2368,
				2339,
				2046,
				1941,
				1819,
				1334
			],
			"Interior Health": [
				673,
				673,
				551,
				536,
				494,
				306
			],
			"Northern Health": [
				307,
				295,
				247,
				236,
				206,
				99
			],
			"Vancouver Coastal Health": [
				4906,
				4796,
				4135,
				3874,
				3582,
				2686
			],
			"Vancouver Island Health": [
				1131,
				1121,
				992,
				954,
				874,
				611
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_7.json
// module id = 172
// module chunks = 0